


import { Component, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";

import ResultComponent from '../Result/Result.vue';

import InfiniteScrollDirective from '@/shared/directives/infinite-scroll-directive';

@Component({
    components: {
        ResultComponent
    },
    computed: {
        ...mapGetters(["notLastResult", "results", "config"])
    },
    directives: {
        InfiniteScrollDirective
    }
})
export default class ResultsListComponent extends Vue {
    public loadMore(last: boolean) {
        if (last) {
            this.$store.dispatch('loadMore');
        }
    }

    public loadAll() {
        this.$store.dispatch('loadAll');
    }
}
